export default __webpack_public_path__ + "static/media/430.fc112405.gif";